import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import Loader from "@/components/Loader/LoaderView";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import CreateDocumentApproval from "@/components/CreateDocumentApproval/CreateDocumentApproval.vue";

export default {
  props: {
    is_public: {
      type: Boolean,
      default: false,
    },
    portal_admin: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: ''
    },
  },
  components: {
    Loader,
    Multiselect,
    CreateDocumentApproval
  },
  computed: {
    portal_id() {
      return this.$route.params.portal_id;
    },

    pendingDocuments() {
      return this.document_approvals.filter(doc => doc.status.name === 'pending')
    },
    approvedDocuments() {
      return this.document_approvals.filter(doc => doc.status.name === 'approved')
    },
    rejectedDocuments() {
      return this.document_approvals.filter(doc => doc.status.name === 'rejected')
    },

    noApprovalDocuments() {
      return this.document_approvals.filter(doc => doc.status.name === 'no_approval')
    },
    changesRequestedDocuments() {
      return this.document_approvals.filter(doc => doc.status.name === 'request_changes')
    },
    filteredDocuments() {
      switch (this.active_tab) {
        case 'pending':
          return [...(this.pendingDocuments || []),];
        case 'approved':
          return this.approvedDocuments || [];
        case 'rejected':
          return this.rejectedDocuments || [];
        case 'no_approval':
          return this.noApprovalDocuments || [];
        case 'request_changes':
          return this.changesRequestedDocuments || [];
        default:
          return this.document_approvals || [];
      }
    },
  },
  mounted() {
    this.user_details = get_user_details();
    this.user_id = this.get_user_id();
    this.fetch_document_approval_request();
    const document_approval_modal = $('#edit_document_modal');

    document_approval_modal.on('shown.bs.modal', () => {
      this.fetchPortalMembers();
    });

  },
  beforeUnmount() {
  this.is_destroyed = true;

  this.stopPolling();

  if (this.loading_timeout) {
    clearTimeout(this.loading_timeout);
    this.loading_timeout = null;
  }

  const document_approval_modal = $('#edit_document_modal');
  document_approval_modal.off('shown.bs.modal');

  const document_comment_modal = $('#document_comment_modal');
  document_comment_modal.off('hidden.bs.modal');

  const create_document_approval_modal = $('#document_approval_modal');
  create_document_approval_modal.off('show.bs.modal');
  create_document_approval_modal.off('hidden.bs.modal');
},

  beforeDestroy() {
    this.stopPolling();
  },

  watch: {
    '$route.params.portal_id'() {
      this.fetch_document_approval_request();
      this.startPolling();
    }
  },

  data() {

    return ({
      user_id: null,
      user_details: {
        "user_role": '',
        "user_id": null,
      },
      document_approvals: [],
      loading: true,
      reviewers: [],
      edit_documents: [],
      fileError: '',
      errors: {

      },
      edit_previews: [],
      edit_upload_files: [],
      edit_isDragging: false,
      temporary_post: null,
      previewDocumentType: '',
      previewDocumentUrl: '',
      loading_preview: false,
      active_tab: 'pending',
      document_name: '',
      document_description: '',
      document_id: null,
      tempSelectedReviewer: [],
      polling_instance: null,
      poll_interval_time: 5000,
      is_fetching: false,
      document_comment_title: '',
      document_comment_text: '',
      document_comment_error: '',
      document_comment_editor_visible: false,
      document_comment_editor_key: 0,
      document_comment_prompt_resolver: null
    })
  },

  methods: {
    setActiveTab(tab) {
      this.active_tab = tab
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    formatStatus(status) {
      switch (status) {
        case 'request_changes': return 'Changes Requested';
        case 'pending': return 'Pending Review';
        case 'approved': return 'Approved';
        case 'rejected': return 'Rejected';
        case 'no_approval': return 'No Approval Needed';
        default: return status;
      }
    },

    reviewer_comments(document) {
      return (document?.reviewer || []).filter((reviewer) => reviewer.comment && reviewer.comment.trim());
    },

    has_reviewer_comments(document) {
      return this.reviewer_comments(document).length > 0;
    },

    getToken() {
      return get_token();
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    handle_temporary_document(temporary_document) {
      this.temporary_post = temporary_document;
    },
    handle_document_created(document) {
      this.add_document_approval(document);
    },
    get_editor_plain_text(editorRef) {
      const editor = editorRef?.getQuill?.() || editorRef?.getEditor?.();

      if (editor?.getText) {
        return editor.getText().trim();
      }

      if (typeof editorRef?.getText === 'function') {
        return editorRef.getText().trim();
      }

      const fallbackText = document.createElement('div');
      fallbackText.textContent = this.document_description || '';
      return fallbackText.textContent.trim();
    },

    encode_description_text(description) {
      return String(description || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },

    is_next_reviewer(document) {
      const reviewers = document?.reviewer || [];
      const userId = Number(this.user_details?.user_id);

      if (!reviewers.length || !userId) return false;

      // Normalize ID
      const getId = r => typeof r.user_id === 'object' ? Number(r.user_id?.value || r.user_id) : Number(r.user_id);

      // Sort reviewers by review_order
      const sorted = [...reviewers].sort((a, b) => a.review_order - b.review_order);

      // Find first reviewer with pending status
      const nextReviewer = sorted.find(r => r.status === 'pending');
      if (!nextReviewer) return false;

      // ✅ Only show buttons if current user is the *next pending* reviewer
      return getId(nextReviewer) === userId;
    },

    is_reviewer(document) {
      if (!document || !document.reviewer || !this.user_id) {
        return false;
      }

      return document.reviewer.some((r) => r.user_id === parseInt(this.user_id, 10));

    },

    fetchPortalMembers() {
      if (this.reviewers.length > 0) return; // Only fetch if not already loaded

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
        method: "GET",
        data: { portal_id: this.portal_id },
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        success: (response) => {
          if (response.status === "success") {
            const currentUserId = Number(this.user_details.user_id);
            this.reviewers = response.data.members
              .filter(member => member.user && member.user.id !== currentUserId)
              .map(member => ({
                portal_access_id: member.id,   // 🔥 IMPORTANT FIX (OR member.portal_access_id if backend provides it)
                user: member.user,
                first_name: member.user.first_name,
                last_name: member.user.last_name,
                full_name: `${member.user.first_name} ${member.user.last_name}`
              }));
          }
        },
        error: (xhr) => {
          console.error("Error fetching portal members:", xhr);
        },
      });
    },

    startPolling() {

      this.stopPolling();
      
      this.polling_instance = setInterval(() => {
        this.fetch_document_approval_request(true);
      }, this.poll_interval_time);
    },
    
    stopPolling() {
      if (this.polling_instance) {
        clearInterval(this.polling_instance);
        this.polling_instance = null;
      }
    },

    fetch_document_approval_request(is_background_poll = false) {
  if (this.is_destroyed) return;

  const portal_id = this.$route.params.portal_id;

  const payload = {
    portal_id: portal_id
  };

  if (this.is_fetching) {
    return;
  }

  this.is_fetching = true;

  const is_background = is_background_poll === true;

  if (!is_background) {
    this.loading = true;
  }

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_document_approval/`,
    method: 'POST',
    data: JSON.stringify(payload),
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json',
    },
    success: (response) => {
      if (this.is_destroyed) return;

      this.document_approvals = response?.data?.document_approvals || [];
    },
    error: (xhr) => {
      if (this.is_destroyed) return;

      console.error('Failed to fetch document approvals:', xhr);
      this.document_approvals = [];
    },
    complete: () => {
      if (this.is_destroyed) return;

      this.is_fetching = false;

      if (!is_background) {
        this.loading_timeout = setTimeout(() => {
          if (!this.is_destroyed) {
            this.loading = false;
          }
        }, 1000);
      }
    }
  });
},

    getFileIcon(fileUrl) {
      if (fileUrl.includes('.pdf'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337946.png'; // PDF
      if (fileUrl.includes('.doc') || fileUrl.includes('.docx'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337932.png'; // Word
      if (fileUrl.includes('.xls') || fileUrl.includes('.xlsx'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337958.png'; // Excel
      if (fileUrl.includes('.pptx') || fileUrl.includes('.pptx'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337949.png'; // PowerPoint
      if (fileUrl.includes('.png') || fileUrl.includes('.png'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337948.png';
      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default
    },

    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },

    handleEditApprovalDrop(event) {
      this.edit_isDragging = false;
      const files = Array.from(event.dataTransfer.files || []);
      this.addEditApprovalPreviewFiles(files);
    },

    handleEditFileUpload(event) {
      const files = Array.from(event.target.files || []);
      this.addEditApprovalPreviewFiles(files);
      event.target.value = '';
    },

    addEditApprovalPreviewFiles(files = []) {
      if (!files.length) return;

      this.fileError = '';
      const MAX_FILES = 10;

      if (files.length + this.edit_upload_files.length > MAX_FILES) {
        this.fileError = `Maximum ${MAX_FILES} files allowed.`;
        return;
      }

      files.forEach((file) => {
        if (file.type.startsWith('audio/')) {
          this.fileError = 'Audio files are not allowed.';
          return;
        }

        this.edit_upload_files.push(file);

        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.edit_previews.push({
              type: "image",
              src: e.target.result,
              name: file.name,
            });
          };
          reader.readAsDataURL(file);
        } else if (file.type.startsWith("video/")) {
          this.edit_previews.push({
            type: "video",
            src: URL.createObjectURL(file),
            name: file.name,
          });
        } else {
          this.edit_previews.push({
            type: "file",
            name: file.name,
            extension: file.name.split('.').pop().toLowerCase(),
          });
        }
      });
    },

    removeEditApprovalFile(index) {
      const [preview] = this.edit_previews.splice(index, 1);
      this.edit_upload_files.splice(index, 1);

      if (preview?.src && preview.type === "video") {
        URL.revokeObjectURL(preview.src);
      }

      const lastFile = this.edit_upload_files[this.edit_upload_files.length - 1] || null;
      if (!lastFile) {
        this.fileError = '';
      }
    },

    // Validate form before submitting
    close_document_dropdowns() {
      document.querySelectorAll('.dropdown-menu.show').forEach((menu) => {
        menu.classList.remove('show');
      });
      document.querySelectorAll('[data-bs-toggle="dropdown"][aria-expanded="true"]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
      });
    },

    open_edit_document_modal(document) {
      this.close_document_dropdowns();
      this.edit_document(document);
      this.$nextTick(() => {
        $('#edit_document_modal').modal('show');
      });
    },

    edit_document(document) {
      this.document_name = document.name;
      this.document_description = document.description;
      this.document_id = document.id;
      this.edit_documents = document;
      this.edit_previews.forEach((preview) => {
        if (preview?.src && preview.type === "video") {
          URL.revokeObjectURL(preview.src);
        }
      });
      this.edit_previews = [];
      this.edit_upload_files = [];
      this.edit_isDragging = false;
      this.fileError = '';

      // Populate tempSelectedReviewer for the multiselect
      if (document.reviewer && Array.isArray(document.reviewer)) {
        this.tempSelectedReviewer = document.reviewer.map(r => ({
          portal_access_id: r.portal_access_id,
          name: r.name,
          status: r.status,
          review_order: r.review_order
        }));
      } else {
        this.tempSelectedReviewer = [];
      }

      this.$nextTick(() => {
        const editorRef = this.$refs.quillDocumentEditorRef;
        const quillEditor = editorRef?.getQuill?.() || editorRef?.getEditor?.();
        const description = this.document_description || "";

        if (quillEditor?.clipboard?.dangerouslyPasteHTML) {
          quillEditor.clipboard.dangerouslyPasteHTML(description);
        } else if (quillEditor?.setText) {
          quillEditor.setText(description.replace(/<[^>]*>/g, ""));
        } else if (editorRef?.setHTML) {
          editorRef.setHTML(description);
        }
      });
    },

    edit_document_data() {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      const formData = new FormData();
      const documentDescription = this.encode_description_text(
        this.get_editor_plain_text(this.$refs.quillDocumentEditorRef)
      );
      formData.append('document_name', this.document_name);
      formData.append('description', documentDescription);
      formData.append('document_approval_id', this.document_id);

      // Append reviewers
      const reviewerIds = this.tempSelectedReviewer
        .filter(r => r && r.portal_access_id)
        .map(r => r.portal_access_id);
      reviewerIds.forEach(id => {
        formData.append('reviewer', id);
      });

      const baseUrl = `${window.location.origin}${this.$route.path}`;
      const documentUrl = `${baseUrl}?portal_id=${this.portal_id}`;
      formData.append('base_url', documentUrl);

      this.edit_upload_files.forEach((file) => {
        formData.append('file', file);
      });

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_document_approval/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === 'success') {
            const updatedDocument = response.data;
            if (Array.isArray(this.document_approvals)) {
              const documentIndex = this.document_approvals.findIndex(
                (hub) => hub.id === updatedDocument.id
              );

              if (documentIndex !== -1) {
                this.document_approvals.splice(documentIndex, 1, updatedDocument);
              }
            } else {
              console.error('document_approvals is not an array:', this.document_approvals);
            }

            Swal.fire({
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#edit_document_modal').modal('hide');
              this.resetSelection();
            });
          }
        },
        error: (response) => {
          Swal.close()
          const response_data = response.responseJSON;
          this.errors.edit_name = response_data.message
        },
      });
    },

    resetSelection() {
      this.document_name = '';
      this.document_description = '';
      this.document_id = null;
      this.tempSelectedReviewer = [];
      this.edit_documents = [];
      this.edit_previews.forEach((preview) => {
        if (preview?.src && preview.type === "video") {
          URL.revokeObjectURL(preview.src);
        }
      });
      this.edit_previews = [];
      this.edit_upload_files = [];
      this.edit_isDragging = false;

      this.errors = {}

    },

    approve_document(document_approval_id) {
      const PORTAL_ID = this.$route.params.portal_id;
      const baseUrl = `${window.location.origin}`;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/approve_document_approval/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          portal_id: PORTAL_ID,
          base_url: baseUrl,
          document_approval_id: document_approval_id
        }),
        success: (data) => {
          if (data.status === "success") {
            const updatedDoc = data.data; // This is the updated document from backend
            const approvalStatus = updatedDoc.status.name;

            let message =
              approvalStatus === "approved"
                ? "Document approved and moved to the approved folder."
                : "Your approval has been recorded. Waiting for other reviewers.";

            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: message,
              showConfirmButton: false,
              timer: 1500,
              position: 'bottom-end',
              toast: true
            });

            // If fully approved → remove from pending list
            if (approvalStatus === "approved") {
              this.document_approvals = this.document_approvals.filter(
                (doc) => doc.id !== updatedDoc.id
              );
            } else {

              this.document_approvals = this.document_approvals.map(doc =>
                doc.id === updatedDoc.id ? updatedDoc : doc
              );
            }
          }
        },
        error: (xhr) => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: xhr.responseJSON?.message || 'Failed to approve document. Please try again.',
            confirmButtonText: 'OK',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
      });
    },
    showDocumentCommentPrompt(title, initialValue = '') {
      this.document_comment_title = title;
      this.document_comment_text = initialValue || '';
      this.document_comment_error = '';
      this.document_comment_editor_visible = false;
      this.document_comment_editor_key += 1;

      return new Promise((resolve) => {
        this.document_comment_prompt_resolver = resolve;

        this.$nextTick(() => {
          const modalElement = document.getElementById('document_comment_modal');
          if (!modalElement) {
            resolve({ isConfirmed: false });
            this.document_comment_prompt_resolver = null;
            return;
          }

          modalElement.addEventListener('shown.bs.modal', () => {
            this.document_comment_editor_visible = true;
            this.$nextTick(() => {
              this.set_document_comment_editor_text(this.document_comment_text);
            });
          }, { once: true });

          modalElement.addEventListener('hidden.bs.modal', () => {
            this.document_comment_editor_visible = false;
            this.resolve_document_comment_prompt(false);
          }, { once: true });

          this.document_comment_modal_instance(modalElement)?.show();
        });
      });
    },

    document_comment_modal_instance(modalElement) {
      if (window.bootstrap?.Modal) {
        return window.bootstrap.Modal.getOrCreateInstance(modalElement);
      }

      return ({
        show: () => $('#document_comment_modal').modal('show'),
        hide: () => $('#document_comment_modal').modal('hide')
      });
    },

    get_reviewer_user_id(reviewer) {
      const reviewerId = reviewer?.user_id;

      if (typeof reviewerId === 'object' && reviewerId !== null) {
        return String(reviewerId.value || reviewerId.id || '');
      }

      return String(reviewerId || '');
    },

    set_document_comment_editor_text(comment = '') {
      const editor = this.$refs.documentCommentQuillRef?.getQuill?.() || this.$refs.documentCommentQuillRef?.getEditor?.();

      if (!editor) {
        return;
      }

      if (editor.clipboard?.dangerouslyPasteHTML) {
        editor.setText('', 'silent');
        editor.clipboard.dangerouslyPasteHTML(0, comment || '', 'silent');
      }
    },

    submit_document_comment_prompt() {
      const plainComment = this.get_editor_plain_text(this.$refs.documentCommentQuillRef);
      const comment = this.get_editor_html(this.$refs.documentCommentQuillRef);

      if (!plainComment) {
        this.document_comment_error = 'Comment is required.';
        return;
      }

      this.resolve_document_comment_prompt(true, comment);

      const modalElement = document.getElementById('document_comment_modal');
      if (modalElement) {
        this.document_comment_modal_instance(modalElement)?.hide();
      }
    },

    get_editor_html(editorRef) {
      const editor = editorRef?.getQuill?.() || editorRef?.getEditor?.();
      return editor?.root?.innerHTML?.trim() || '';
    },

    get_document_comment_html(comment) {
      return comment || '';
    },

    resolve_document_comment_prompt(isConfirmed, value = '') {
      if (!this.document_comment_prompt_resolver) {
        return;
      }

      const resolver = this.document_comment_prompt_resolver;
      this.document_comment_prompt_resolver = null;
      this.document_comment_error = '';
      resolver({ isConfirmed, value });
    },


    reject_document(document_approval_id) {
      this.showDocumentCommentPrompt('Document Rejection').then((result) => {
        if (result.isConfirmed) {
          const PORTAL_ID = this.$route.params.portal_id;
          const baseUrl = `${window.location.origin}${this.$route.path}`
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reject_document_approval/`,
            method: 'POST',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data: JSON.stringify({
              portal_id: PORTAL_ID,
              base_url: baseUrl,
              document_approval_id: document_approval_id,
              reason: result.value
            }),
            success: (data) => {
              if (data.status === "success") {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: data.message,
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  // Replace only the updated document with the new one returned by the API
                  this.document_approvals = this.document_approvals.map(doc =>
                    doc.id === data.data.id ? data.data : doc
                  );
                });
              }
            },
            error: (xhr) => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: xhr.responseJSON?.message || 'Failed to reject document. Please try again.',
                confirmButtonText: 'OK',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            },
          });
        }
      });
    },
requestChanges(document) {
  const my_comment = this.reviewer_comments(document)?.find(reviewer =>
    String(reviewer.user_id) === String(this.user_details.user_id)
  )?.comment || '';

  this.showDocumentCommentPrompt('Request Changes', my_comment).then((result) => {
    if (!result.isConfirmed) return;

    const PORTAL_ID = this.$route.params.portal_id;
    const baseUrl = `${window.location.origin}${this.$route.path}`;

    const is_request_changes =
      document.status?.name === 'request_changes' ||
      document.status === 'request_changes';

    const url = is_request_changes
      ? `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_document_change_comment/`
      : `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/request_document_change/`;

    const payload = is_request_changes
      ? {
          document_approval_id: document.id,
          comment: result.value
        }
      : {
          portal_id: PORTAL_ID,
          base_url: baseUrl,
          document_approval_id: document.id,
          reason: result.value
        };

    $.ajax({
      url,
      method: 'POST',
      headers: {
        Authorization: `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload),
      success: (data) => {
        if (data.status === 'success') {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: data.message,
            showConfirmButton: false,
            timer: 1000,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            this.document_approvals = this.document_approvals.map(doc =>
              doc.id === data.data.id ? data.data : doc
            );
          });
        }
      }
    });
  });
},
    previewDocument(fileObj) {
      if (fileObj && fileObj.file && fileObj.file.file_url) {
        const fileUrl = fileObj.file.file_url;
        const fileType = this.getFileType(fileUrl);

        // show loader before setting url
        this.loading_preview = true;

        if (fileType === 'word' || fileType === 'excel' || fileType === 'powerpoint') {
          this.previewDocumentUrl = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileUrl);
        } else {
          this.previewDocumentUrl = fileUrl;
        }
        this.previewDocumentType = fileType;
        $("#document_preview_modal").modal("show");
      } else {
        console.error("File object or file URL is missing");
      }
    },

    getFileType(url) {
      if (typeof url !== 'string') return 'unknown';

      try {
        const parsedUrl = new URL(url);
        const pathname = parsedUrl.pathname; // Gets the part after the domain
        const filename = pathname.split('/').pop(); // Gets "Workstreams -Sprint 13 (3).docx"
        const extension = filename.split('.').pop().toLowerCase();

        if (extension === 'pdf') return 'pdf';
        if (['doc', 'docx'].includes(extension)) return 'word';
        if (['xls', 'xlsx'].includes(extension)) return 'excel';
        if (['ppt', 'pptx'].includes(extension)) return 'powerpoint';
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) return 'image';

        return 'unknown';
      } catch (error) {
        console.error("Invalid URL in getFileType:", error);
        return 'unknown';
      }
    },



    deleteDocument(document_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_document_approval/`,
            method: 'DELETE',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data: JSON.stringify({
              document_approval_id: document_id
            }),
            success: (data) => {
              if (data.status === "success") {
                this.document_approvals = this.document_approvals.filter(doc => doc.id !== document_id);
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Document deleted successfully.',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  Swal.close();

                });
              }
            },
          });
        }
      });
    },

    add_document_approval(new_document) {

      if (new_document) {

        this.document_approvals.unshift(new_document);

        const ref = this.$refs.documentApprovalRef;

        if (ref && Array.isArray(ref.document_approvals)) {
          ref.document_approvals.unshift(new_document);
        } else if (ref) {
          ref.document_approvals = [new_document];
        }
      }
      this.temporary_post = null;
    },
    truncate_document_name(name, max_length =30) {
      if (name.length > max_length) {
        return name.slice(0, max_length) + '...';
      }
      return name;
    },
  }
};
